import InputField from 'components/form-fields/formik/InputField';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Form, Segment } from 'semantic';
import { buildFormPath } from 'screens/GroupsAndPolicies/formpath';
import { TimeFormatField } from 'screens/GroupsAndPolicies/Fields/TimeFormatField';

type Props = {
  basePath: string;
};

export const DurationRestriction = (props: Props) => {
  const { t } = useTranslation();

  return (
    <>
      <Form.Field>
        <label>{t('restrictions.duration.label', 'Session duration')}</label>
      </Form.Field>
      <Segment>
        <Form.Group>
          <TimeFormatField name={buildFormPath('format', props.basePath)} />
          <InputField
            name={buildFormPath('min', props.basePath)}
            type="number"
            label={t('tariff.restrictions.minDuration', 'Min session time')}
          />

          <InputField
            name={buildFormPath('max', props.basePath)}
            type="number"
            label={t('tariff.restrictions.maxDuration', 'Max session time')}
          />
        </Form.Group>
      </Segment>
    </>
  );
};
